import * as Yup from "yup";

export function initialValues(courseTeacher) {
  return {
    gradeId: courseTeacher?.gradeId || "",
    subjectId: courseTeacher?.subjectId || "",
    userId: courseTeacher?.userId || "",
  };
}

export function validationSchema() {
  return Yup.object({
    gradeId: Yup.string().nullable().required("El grado es obligatorio"),
    subjectId: Yup.string().nullable().required("La asignatura es obligatoria"),
    userId: Yup.string().nullable().required("El docente es obligatorio"),
  });
}
